import { useState } from 'react';

const ImageWithFallback = ({ src, alt, fallback, className, ...props }) => {
    const [errorCount, setErrorCount] = useState(0);

    const defaultImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAAKklEQVR4nO3NQQEAAATAQPTvRxwl+N0C7LJn4rN6vQMAAAAAAAAAAIDDFjHRAsfjVR3HAAAAAElFTkSuQmCC";

    const handleError = (e) => {
        setErrorCount(prev => prev + 1);

        if (errorCount === 0) {
            e.target.src = fallback;
        } else if (errorCount === 1) {
            e.target.src = defaultImage;
        }
    };

    return (
        <img
            className={className}
            src={src}
            alt={alt}
            onError={handleError}
            {...props}
        />
    );
};

export default ImageWithFallback;
